import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tooltip-info',
  templateUrl: './tooltip-info.component.html',
  styleUrls: ['./tooltip-info.component.scss']
})
export class TooltipInfoComponent implements OnInit {

  @Input() message: string;
  @Input() iconType: 'info' | 'question' = 'info';
  @Input() color: string;
  // @Input() styleClass: {};

  constructor() { }

  ngOnInit(): void {
  }

}
